import { graphql, useStaticQuery } from "gatsby";

const DataSourceItems = (contentfulCode = "en") => {
    const dataSourceData = useStaticQuery(graphql`
        query DataSourceQuery {
            dataSources: allContentfulDataSource(sort: { title: ASC }) {
                nodes {
                    id
                    node_locale
                    __typename
                    ... on Node {
                        ...DataSource
                    }
                }
            }
            dataSourceTaxonomies: allContentfulTaxonomy(filter: { title: { eq: "Data Source" } }) {
                nodes {
                    id
                    node_locale
                    name
                    terms {
                        ...DataSourceTerm
                    }
                }
            }
        }
    `);

    // Filter out all data source nodes that aren't in the current language.
    if (Array.isArray(dataSourceData?.dataSources?.nodes)) {
        dataSourceData.dataSources.nodes = dataSourceData.dataSources.nodes.filter(
            (el) => el?.node_locale === contentfulCode
        );
    }

    // Filter out all data source taxonomy nodes that aren't in the current language.
    if (Array.isArray(dataSourceData?.dataSourceTaxonomies?.nodes)) {
        dataSourceData.dataSourceTaxonomies.nodes = dataSourceData.dataSourceTaxonomies.nodes.filter(
            (el) => el?.node_locale === contentfulCode
        );
    }

    return dataSourceData;
};

export default DataSourceItems;
